import { Button } from '@thrivetribe/mvf.ui.atoms.button';
import {
  OnboardingPage,
  OnboardingPageBody,
  OnboardingPageContent,
  OnboardingPageCopy,
} from '@thrivetribe/mvf.ui.organisms.onboarding-page';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ImagesUrl } from 'configs/EnvironmentConfig';
import './ForgotPasswordResent.scss';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { resendForgottenPasswordEmail } from 'helpers/sendForgotPasswordEmail';

export const ForgotPasswordResent = () => {
  const navigate = useNavigate();

  const token = useSelector(
    (state: RootState) => state.forgottenPassword.token
  );  

  const [passwordEmailSent, setPasswordEmailSent] = useState(false);

  const resendPasswordResetEmail = async () => {
    console.log("token: " + token)
    if (token !== '') {     
      await resendForgottenPasswordEmail(token );
      setPasswordEmailSent(true);
    }
  };

  return (
    <div className="reset-password">
      <OnboardingPage
        hideProfile
        image={`${ImagesUrl}/football.webp`}
        title={'Reset your password'}
        onBackClick={() => navigate(-1)}
      >
        <Helmet>
          <title>Reset your password</title>
        </Helmet>
        <OnboardingPageContent>
          <OnboardingPageBody>
            <OnboardingPageCopy>
              <h1>Reset Password link hitting your inbox now</h1>
              <p>
                Click the link in the email (don't take too long, it expires in
                10 minutes) and we'll carry on with your password reset.
              </p>            
              <p>
                Can't see it? Check your spam folder. Still nothing?{' '}
                <Button onClick={resendPasswordResetEmail} variant="text">
                  Resend link
                </Button>
              </p>
              {passwordEmailSent && (
                <span className="email-sent">
                  <CheckCircleOutlineIcon />
                  New reset link on its way
                </span>
              )}  
            </OnboardingPageCopy>
          </OnboardingPageBody>
        </OnboardingPageContent>
      </OnboardingPage>
    </div>
  );
};
